/**
 * Represents the various sort filters you can apply to the people/search-network
 * endpoint on sh-api
 *
 * @const {object}
 */
export const NETWORK_PARAMS_SORT_TYPES = {
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  LAST_SEEN: 'last_seen',
  LAST_HIRED: 'last_hired'
};

/**
 * Represents the various values for the `network` option in a request
 * to the people/search-network endpoint
 *
 * @const {object}
 */
export const NETWORK_PARAMS_NETWORK_TYPES = {
  MINE: 'mine',
  COMPANY: 'company',
  COMPANY_INVITED: 'company_invited',
  COMPANY_NOT_MINE: 'company_not_mine',
  COMPANY_NOT_INVITED: 'company_not_invited',
};

/**
 * Represents the various sorts you can apply to the people/search-network
 * endpoint on sh-api
 *
 * @const {object}
 */
 export const COMPANY_NETWORK_PARAMS_SORT_TYPES = {
  RECENTLY_HIRED: 'recently_hired',
  NAME: 'best_name_match',
  CREATED_AT: 'created_at',
  UPDATED_AT: 'updated_at',
};

/**
 * Represents the various filters you can apply to the people/search-network
 * endpoint on sh-api
 *
 * @const {object}
 */
export const COMPANY_NETWORK_PARAMS_FILTERS = {
  HAS_RATING: 'has_rating',
  USER_TYPE: 'user_type',
};
